.dz{aspect-ratio:1/1;}